import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShopVoucherGQL, ShopVouchersGQL } from './gql/shop-voucher.gql.generated';
import { AuthorizationHeaderProvider, AUTHORIZATION_HEADER_PROVIDER } from './types/shop-auth';
import { IShopVoucher } from './types/shop-voucher';

@Injectable()
export class ShopVoucherService {
  constructor(
    private readonly fetchVouchersGQL: ShopVouchersGQL,
    private readonly fetchVoucherGQL: ShopVoucherGQL,
    @Inject(AUTHORIZATION_HEADER_PROVIDER)
    private authHeader: AuthorizationHeaderProvider,
  ) {}

  fetchVouchers(userId: number): Observable<IShopVoucher[]> {
    return this.fetchVouchersGQL
      .fetch({ userId }, this.authHeader.userAuthHeader)
      .pipe(map((r) => r.data.shopVouchers));
  }

  fetchVoucher(voucherId: number): Observable<IShopVoucher> {
    return this.fetchVoucherGQL
      .fetch({ voucherId }, this.authHeader.userAuthHeader)
      .pipe(map((r) => r.data.shopVoucher));
  }
}
